export default function parseFloat(string) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (string == null) return defaultValue;
  var value = Number.parseFloat(string);
  return Number.isNaN(value) ? defaultValue : value;
}